import React, { useEffect, useState } from "react";
import {
  getAdminName,
  getavailableposition,
  getINRavailableposition
} from "../../../Services/Superadmin/Superadmin";
import AggregatedPosition from "./AggregatedPosition";
import AggregatedINRPosition from "./AggregatedINRPosition";
import {
  AddCondition,
  GetConditions,
} from "../../../Services/Superadmin/Superadmin";
import { fDateTimesec } from "../../../Utils/Date_format/datefromat";

import Dropdown from "react-bootstrap/Dropdown";
import NoData from "../../../Utils/Table/nodata.jpg";
// import { getINROpenPositions } from "../../../Services/Admin/Addmin";

const Position = () => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [adminNames, setAdminNames] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState("");

  // NEW: Active Tab (Default: USD)
  const [activeTab, setActiveTab] = useState("USD");

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  // Modal states
  const [showModal, setShowModal] = useState(false);
  const [logsData, setLogsData] = useState([]);
  const [logsPage, setLogsPage] = useState(0);
  const logsPerPage = 10;

  useEffect(() => {
    setPage(1);
  }, [search, selectedAdmin, activeTab]);

  useEffect(() => {
    getuserallhistory();
  }, [search, selectedAdmin, activeTab, page, limit]); // <-- TAB AND PAGINATION CHANGE EFFECT

  useEffect(() => {
    GetAdminUserName();
  }, []);

  const getuserallhistory = async () => {
    try {
      let response;

      const payload = { 
        page: page,
        limit: limit
      };
      
      if (selectedAdmin) {
        payload.adminid = selectedAdmin;
      }

      // 🔥 Tab-based API
      if (activeTab === "USD") {
        response = await getavailableposition(payload);
      } else {
        response = await getINRavailableposition(payload);
      }

      setData(response.data || []);
      setTotalPages(response.totalPages || 1);
      setTotalCount(response.totalCount || 0);

      const responseData = await GetConditions();
      setLogsData(responseData?.data || []);
    } catch (error) { }
  };

  const GetAdminUserName = async () => {
    try {
      const res = await getAdminName();
      setAdminNames(res.data);
    } catch (error) { }
  };

  const openLogsModal = () => {
    setShowModal(true);
  };

  const closeLogsModal = () => {
    setShowModal(false);
    setLogsPage(0);
  };

  const totalLogsPages = Math.ceil(logsData?.length / logsPerPage);
  const paginatedLogs = logsData.slice(
    logsPage * logsPerPage,
    (logsPage + 1) * logsPerPage
  );

  return (
    <div className="container-fluid mt-5">

      {/* -------------------- NEW TABS ADDED -------------------- */}
      {/* <div className="row mb-3">
        <div className="col-lg-12">
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "USD" ? "active fw-bold" : ""}`}
                onClick={() => setActiveTab("USD")}
              >
                💲 USD Positions
              </button>
            </li>

            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "INR" ? "active fw-bold" : ""}`}
                onClick={() => setActiveTab("INR")}
              >
                🇮🇳 INR Positions
              </button>
            </li>
          </ul>
        </div>
      </div> */}
      {/* -------------------------------------------------------- */}

      <div className="row">
        <div className="col-lg-12">
          <div className="card transaction-table">
            <div className="card-header border-0 flex-wrap  d-flex justify-content-between align-items-center">
              <h4 className="card-title ">
                {activeTab === "USD" ? "📈 USD Open Positions" : "📈 INR Open Positions"}
              </h4>

              <div className="d-flex align-items-center gap-2">

                {/* Tabs next to Show Logs */}
                <div
                  className="wallet-tabs"
                  style={{
                    background: "#eef2f7",
                    padding: "3px 4px",
                    borderRadius: "40px",
                    display: "flex",
                    alignItems: "center",
                    gap: "0px",
                    border: "1px solid #d4d8dd",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                  }}
                >

                  {/* USD TAB */}
                  <div
                    onClick={() => setActiveTab("USD")}
                    style={{
                      padding: "6px 18px",
                      fontSize: "14px",
                      fontWeight: "600",
                      borderRadius: "40px",
                      cursor: "pointer",
                      textAlign: "center",
                      background: activeTab === "USD" ? "#0d6efd" : "transparent",
                      color: activeTab === "USD" ? "#fff" : "#0d6efd",
                      transition: "0.25s",
                    }}
                  >
                    <i className="fas fa-dollar-sign me-1"></i>
                    USD
                  </div>

                  {/* INR TAB */}
                  <div
                    onClick={() => setActiveTab("INR")}
                    style={{
                      padding: "6px 18px",
                      fontSize: "14px",
                      fontWeight: "600",
                      borderRadius: "40px",
                      cursor: "pointer",
                      textAlign: "center",
                      background: activeTab === "INR" ? "#0d6efd" : "transparent",
                      color: activeTab === "INR" ? "#fff" : "#0d6efd",
                      transition: "0.25s",
                    }}
                  >
                    <i className="fas fa-rupee-sign me-1"></i>
                    INR
                  </div>

                </div>

                {/* Show Logs Button */}
                <button
                  className="btn text-white py-2 "
                  style={{ border: "1px solid #11141aff", background: "#0d6efd" }}
                  onClick={openLogsModal}
                >
                  📋 Show Logs
                </button>

              </div>

            </div>

            <div className="card-body p-0">
              <div className="tab-content">
                <div className="tab-pane fade show active">
                  <div className="d-flex flex-wrap gap-3 p-3 mt-3 rounded shadow-sm">
                    <div>
                      <label className="form-label mb-1">🔍 Search</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Type to search..."
                        style={{ width: "220px", borderRadius: "8px" }}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div>
                    <div>
                      <label className="form-label mb-1">🛡️ Admins</label>
                      <select
                        className="form-select"
                        style={{
                          width: "220px",
                          borderRadius: "8px",
                          background: "var(--bs-light, #f8fafc)",
                          border: "1.5px solid #2563eb55",
                          fontWeight: 500,
                          color: "#313641ff",
                          boxShadow: "0 1px 4px rgba(37,99,235,0.07)",
                          transition: "border-color 0.2s, box-shadow 0.2s",
                          padding: "8px ",
                        }}
                        value={selectedAdmin}
                        onChange={(e) => setSelectedAdmin(e.target.value)}
                      >
                        <option value="" style={{ color: "#64748b" }}>
                          Select Admin
                        </option>
                        {adminNames.map((item, index) => (
                          <option
                            key={index}
                            value={item._id}
                            style={{
                              color: "#1e293b",
                              background: "#fff",
                              fontWeight: 500,
                            }}
                          >
                            {item.UserName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  {data?.length > 0 ? (
                    <>
                      {activeTab === "USD" ? (
                        <AggregatedPosition groupedData={data} search={search} />
                      ) : (
                        <AggregatedINRPosition groupedData={data} search={search} />
                      )}
                      {/* PAGINATION CONTROLS */}
                      <div className="d-flex justify-content-between align-items-center mt-3 p-3 border-top">
                        <div className="d-flex align-items-center gap-2">
                          <label className="form-label mb-0" style={{ fontWeight: 500 }}>Rows per page:</label>
                          <select
                            className="form-select form-select-sm"
                            value={limit}
                            onChange={(e) => {
                              setLimit(Number(e.target.value));
                              setPage(1);
                            }}
                            style={{ width: "80px" }}
                          >
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                        </div>
                        <div className="d-flex gap-2 align-items-center">
                          <button
                            className="btn btn-sm btn-outline-primary"
                            disabled={page <= 1}
                            onClick={() => setPage((prev) => prev - 1)}
                          >
                            ◀ Prev
                          </button>
                          <span style={{ fontWeight: 500 }}>
                            Page {page} of {totalPages || 1}
                          </span>
                          <button
                            className="btn btn-sm btn-outline-primary"
                            disabled={page >= totalPages}
                            onClick={() => setPage((prev) => prev + 1)}
                          >
                            Next ▶
                          </button>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="d-flex justify-content-center align-items-center flex-column">
                      <img src={NoData} alt="No Data" style={{ width: "20%" }} />
                      <h4 className="text-muted">No Data Available</h4>
                    </div>
                  )}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ------------------ LOGS MODAL (YOUR FULL CODE) ------------------ */}
      {showModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{
            backgroundColor: "rgba(0,0,0,0.35)",
            backdropFilter: "blur(7px)",
            WebkitBackdropFilter: "blur(7px)",
            transition: "backdrop-filter 0.3s",
            zIndex: 1050,
          }}
        >
          <div className="modal-dialog modal-xl modal-dialog-centered" style={{ maxWidth: "1100px" }}>
            <div
              className="modal-content"
              style={{
                borderRadius: "18px",
                boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.18)",
                border: "none",
                overflow: "hidden",
                animation: "fadeInModal 0.35s cubic-bezier(.4,0,.2,1)",
                background: "rgba(255,255,255,0.97)",
              }}
            >
              {/* YOUR FULL MODAL CODE REMAINS SAME */}
              {/* (Nothing removed, nothing changed) */}
              {/* ---------------------------------------------------------- */}

              {/* HEADER */}
              <div
                className="modal-header bg-primary text-white"
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 2,
                  borderBottom: "1px solid #e3e6f0",
                  background: "linear-gradient(90deg, #2563eb 0%, #1e40af 100%)",
                  boxShadow: "0 2px 8px rgba(37,99,235,0.08)",
                }}
              >
                <h5 className="modal-title fw-bold" style={{ letterSpacing: 1 }}>
                  📋 Logs
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={closeLogsModal}
                  style={{ filter: "brightness(1.7)" }}
                ></button>
              </div>

              {/* BODY */}
              <div
                className="modal-body"
                style={{
                  maxHeight: "65vh",
                  overflowY: "auto",
                  padding: "2rem 1.5rem 1.5rem 1.5rem",
                  background: "rgba(250,252,255,0.98)",
                }}
              >
                <table
                  className="table table-bordered table-hover align-middle mb-0"
                  style={{
                    borderRadius: "12px",
                    overflow: "hidden",
                    background: "#fff",
                    boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
                  }}
                >
                  <thead
                    className=" table-primary sticky-top"
                    style={{
                      zIndex: 1,
                      background: "#e3eefd",
                      fontWeight: 600,
                      fontSize: "1.04em",
                      letterSpacing: "0.5px",
                      borderBottom: "2px solid #375986ff",
                    }}
                  >
                    <tr>
                      <th style={{ color: "#000" }}>#</th>
                      <th style={{ color: "#000" }}>Symbol</th>
                      <th style={{ color: "#000" }}>Initial Price</th>
                      <th style={{ color: "#000" }}>Drop Threshold</th>
                      <th style={{ color: "#000" }}>Time Window</th>
                      <th style={{ color: "#000" }}>Status</th>
                      <th style={{ color: "#000" }}>Triggered</th>
                      <th style={{ color: "#000" }}>Created At</th>
                      <th style={{ color: "#000" }}>Logs</th>
                    </tr>
                  </thead>


                  <tbody>
                    {paginatedLogs?.length === 0 && (
                      <tr>
                        <td colSpan={9} className="text-center text-muted py-4">
                          No logs found.
                        </td>
                      </tr>
                    )}
                    {paginatedLogs.map((log, i) => (
                      <tr key={i}>
                        <td className="fw-semibold">
                          {logsPage * logsPerPage + i + 1}
                        </td>
                        <td>{log.symbol}</td>
                        <td>{log.initialPrice}</td>
                        <td>{log.dropThreshold}</td>
                        <td>{log.timeWindow}</td>
                        <td>
                          <span
                            className={`badge rounded-pill ${log.isActive ? "bg-success" : "bg-secondary"
                              }`}
                          >
                            {log.isActive ? "On" : "Off"}
                          </span>
                        </td>
                        <td>
                          <span
                            className={`badge rounded-pill ${log.triggered ? "bg-warning text-dark" : "bg-secondary"
                              }`}
                          >
                            {log.triggered ? "On" : "Off"}
                          </span>
                        </td>
                        <td>{log.createdAt ? fDateTimesec(log.createdAt) : "-"}</td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="outline-primary"
                              size="sm"
                              className="rounded-pill"
                            >
                              View Logs ({log?.logs?.length})
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                              style={{
                                maxHeight: "400px",
                                overflowY: "auto",
                                minWidth: "250px",
                              }}
                            >
                              {log?.logs?.length === 0 && (
                                <Dropdown.Item disabled>No log entries</Dropdown.Item>
                              )}
                              {log?.logs?.map((data) => (
                                <Dropdown.Item key={data._id}>
                                  <div>
                                    <span className="fw-bold" style={{ color: "#000" }}>💵 Price:</span>
                                    <span style={{ color: "#000" }}> {data.price}</span>
                                  </div>
                                  <small className="text-muted">
                                    🕒 {fDateTimesec(data.time)}
                                  </small>
                                </Dropdown.Item>
                              ))}
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* FOOTER */}
              <hr style={{ margin: 0, borderTop: "1.5px solid #e3e6f0" }} />
              <div
                className="modal-footer bg-light d-flex flex-column flex-md-row justify-content-between align-items-center"
                style={{
                  borderTop: "none",
                  padding: "1.2rem 2rem",
                  background: "rgba(245,247,250,0.98)",
                }}
              >
                <div>
                  <button
                    className="btn btn-secondary rounded-pill px-4"
                    onClick={closeLogsModal}
                  >
                    Close
                  </button>
                </div>
                <div className="d-flex justify-content-end gap-2 mt-2 mt-md-0">
                  <button
                    className="btn btn-sm btn-outline-primary"
                    disabled={logsPage === 0}
                    onClick={() => setLogsPage((prev) => prev - 1)}
                  >
                    ◀ Prev
                  </button>
                  <span style={{ fontWeight: 500 }}>
                    Page {logsPage + 1} of {totalLogsPages || 1}
                  </span>
                  <button
                    className="btn btn-sm btn-outline-primary"
                    disabled={logsPage + 1 >= totalLogsPages}
                    onClick={() => setLogsPage((prev) => prev + 1)}
                  >
                    Next ▶
                  </button>
                </div>
              </div>

              <style>
                {`
                  @keyframes fadeInModal {
                    0% { opacity: 0; transform: translateY(40px); }
                    100% { opacity: 1; transform: translateY(0); }
                  }
                `}
              </style>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Position;
